<template>
  <div id="etapas-compra">
    <div class="etapas-compra-hitos">
      <router-link :to="'/carrito'" :class="stepActive == 1 ? 'hito-activo' : 'hito-inactivo'"
        >Carro de compras</router-link
      >
      <router-link
        :to="stepActive == 1 ? '/carrito' : '/datos-compra'"
        :class="stepActive == 2 ? 'hito-activo' : 'hito-inactivo'"
        >Datos para la compra</router-link
      >
      <router-link
        :to="stepActive != 3 ? { path: $route.path } : '/resumen'"
        :class="stepActive == 3 ? 'hito-activo' : 'hito-inactivo'"
        >Finalizar Compra</router-link
      >
    </div>
  </div>
</template>
<script>
export default {
  name: 'CartBreadcumbs',
  props: ['stepActive'],
};
</script>
